import {
  assistantSuggestionClasses,
  assistantSuggestionListClasses,
  assistantTurnAuthorClasses,
} from '@/modules/assistant/parts/styles';

export type SuggestionListProps = {
  /** The prefilled messages the page's skill offers. */
  suggestions: string[];
  /** Puts a suggestion in the composer. It does NOT send it. */
  onPick: (suggestion: string) => void;
};

/**
 * The page's prefilled suggestions.
 *
 * ---------------------------------------------------------------------------
 * CLICKING FILLS THE COMPOSER; IT DOES NOT SEND
 * ---------------------------------------------------------------------------
 * A suggestion is a starting point, not an instruction. The person may want to
 * narrow it, add a name, or throw it away, and a panel that sent on the click
 * would have taken the decision away from them. So the click fills the composer
 * and the person presses Send.
 */
export function SuggestionList({ suggestions, onPick }: SuggestionListProps) {
  if (suggestions.length === 0) return null;

  return (
    <div className={assistantSuggestionListClasses}>
      <p className={assistantTurnAuthorClasses}>Try asking</p>
      {suggestions.map((suggestion) => (
        <button
          key={suggestion}
          type="button"
          className={assistantSuggestionClasses}
          onClick={() => onPick(suggestion)}
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
}
